import React, { useState, useCallback, useContext } from 'react';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { NavPage } from '../../../services/NavService';
import { CreateProductLineRequest, ProductLineClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { usePromise } from '../../EditorCommon/usePromise';
import { LoadSpinner } from '../../LoadSpinner';
import { AdminNav } from '../AdminNav/AdminNav';
import { SingleProductLineAdmin } from './SingleProductLineAdmin';
import "./ProductLineAdminEditor.scss";

export function ProductLineAdminEditor(props: {

}) {
    const [updateCount, setUpdateCount] = useState(0);
    const [selectedProductLineId, setSelectedProductLineId] = useState<number | undefined>();
    const [isCreating, setIsCreating] = useState(false);
    const client = useClient(ProductLineClient);
    const tc = useContext(TranslationContext);

    const productLines = usePromise(useCallback(async () => {
        const response = await client.getProductLines();
        return {
            productLines: response.productLines,
            updateCount
        };
    },
        [updateCount, client]
    ));

    const selectedProductLine = productLines?.productLines.find(pl => pl.id === selectedProductLineId)

    const productLineItems = productLines?.productLines.map(pl => {
        const classes = ["list-group-item"];
        if (pl.id === selectedProductLineId) {
            classes.push("active");
        }
        return (
            <li key={pl.id}
                className={classes.join(' ')}
                onClick={() => setSelectedProductLineId(pl.id)}
            >{pl.defaultName}</li>
        )
    })

    function onChange() {
        setUpdateCount(updateCount + 1);
    }

    async function startCreateNew() {
        if (isCreating)
            return;
        try {
            setIsCreating(true);
            const response = await client.createProductLine(new CreateProductLineRequest({}));
            setSelectedProductLineId(response.id);
        }
        finally {
            setIsCreating(false);
            onChange();
        }
    }

    return (
        <div className="editor product-line-admin-editor ext-editor">
            <AdminNav page={NavPage.Admin.ProductLine} />

            <div className="left-toolbox">
                {productLineItems === undefined
                    ? <LoadSpinner />
                    : (
                        <ul className="list-group product-line-list" >
                            {productLineItems}
                            <li className="list-group-item"
                                onClick={startCreateNew}>New Product Line...</li>
                        </ul>
                    )
                }

            </div>

            <div className="main-editor">
                {selectedProductLine
                    ? <SingleProductLineAdmin
                        key={selectedProductLine.id + "-" + productLines?.updateCount}
                        productLine={selectedProductLine}
                        onChange={onChange} />
                    : (
                        isCreating
                            ? <LoadSpinner />
                            : <span>{tc.translator("admin product line no selection", "←← Vælg en produktlinje")}</span>
                    )

                }
            </div>
        </div>
    );
}
